import React from "react";
import { generateUsersCSV } from "../../api/SecretAdminAPI.js";
import useBool from "../../hooks/useBool.js";
import {downloadCSV} from "../../lib/FileDownloader.js";
import ButtonPrimary from "../buttons/ButtonPrimary.js";
import RegularHeading from "../header/RegularHeading.js";
import SimpleModal from "../other/SimpleModal.js";
import TextPill from "../other/TextPill.js";
import styles from "./ExportData.module.css";

const ExportData = ({ title, items, headers, filename, exportFullDatabase = false}) => {
    const [isModalOpen, openModal, closeModal] = useBool(false);

    const generateUsersFile = (headers) => {
      console.log('exportFullDatabase', exportFullDatabase);
        if(!exportFullDatabase){
          downloadCSV([headers].concat(items), filename); 
        }else{
          openModal();
          return generateUsersCSV(headers);
        }
    }

    return (
        <RegularHeading>
            {title} <TextPill>{items.length}</TextPill>
            <ButtonPrimary className={styles.exportBtn} onClick={() =>  generateUsersFile([headers])} disabled={items.length === 0}>
                Exportar Dados
            </ButtonPrimary>
            <SimpleModal open={isModalOpen} onClose={closeModal} size="small">
                <h4>A gerar csv de utilizadores.</h4>
                <ButtonPrimary onClick={closeModal}>
                Ok
                </ButtonPrimary>
            </SimpleModal>
        </RegularHeading>
    )
}

export default ExportData;